const STYLES = {
  open: "border-amber-500/50 text-amber-400 bg-amber-500/10",
  planned: "border-sky-400/50 text-sky-300 bg-sky-500/10",
  in_progress: "border-[#83B68B]/50 text-[#83B68B] bg-[#83B68B]/10",
  done: "border-emerald-500/50 text-emerald-400 bg-emerald-500/10",
  declined: "border-border opacity-60",
};
export const FEEDBACK_STATUS_LABELS = { open: "Open", planned: "Planned", in_progress: "In progress", done: "Done", declined: "Declined" };

export function FeedbackStatusChip({ status }) {
  return <span className={`text-[9px] tracking-widest uppercase px-2 py-0.5 rounded-full border ${STYLES[status] || STYLES.open}`} data-testid={`feedback-status-${status}`}>{FEEDBACK_STATUS_LABELS[status] || status}</span>;
}
